import React, { useEffect, useState } from 'react'
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import TableLoading from '../commonUIComponents/TableLoading'
import { useSnackbar } from 'notistack'
import ArchiveIcon from '@mui/icons-material/Archive'
import RecyclingIcon from '@mui/icons-material/Recycling'
import reportService from '../../services/reportService'
import Moment from 'react-moment'
import { Link } from 'react-router-dom'
import IconButton from '@mui/material/IconButton'

const ReportedPostsPage = () => {
  const [reportedPosts, setReportedPosts] = useState()
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [isLastPage, setIsLastPage] = useState(false)
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    setReportedPosts(null)
    fetchReportedPosts()
  }, [page])

  const paginationHandler = () => {
    setPage(page + 1)
  }

  const fetchReportedPosts = () => {
    setLoading(true)
    reportService.getReportedPosts(page, pageSize)
      .then(res => {
        if (reportedPosts && page > 0) {
          setReportedPosts([...reportedPosts, ...res.reportedPosts])
        } else {
          setReportedPosts(res.reportedPosts)
        }
        console.log(res)
        setIsLastPage(res.pagination.isLastPage)
      })
      .catch(err => enqueueSnackbar(err, { variant: 'error' }))
      .finally(() => setLoading(false))
  }

  const updateRow = reportId => {
    const currentReportedPosts = [...reportedPosts]
    currentReportedPosts.forEach(reportedPost => {
      if (reportedPost.id === reportId) {
        reportedPost.archived = !reportedPost.archived
      }
    })
    setReportedPosts(currentReportedPosts)
  }

  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Post ID</TableCell>
            <TableCell>Post Title</TableCell>
            <TableCell>Reporter</TableCell>
            <TableCell>Category</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Date</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reportedPosts?.map(reportedPost => (
            <TableRow key={reportedPost.id}>
              <TableCell>
                <Typography component={Link} to={`/view-post/${reportedPost.postId}`} target="_blank">
                  {reportedPost.postId}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography component={Link} to={`/view-post/${reportedPost.postId}`} target="_blank">
                  {reportedPost.title}
                </Typography>
              </TableCell>
              <TableCell>{reportedPost.nickname}</TableCell>
              <TableCell>{reportedPost.category}</TableCell>
              <TableCell>{reportedPost.reason}</TableCell>
              <TableCell>
                <Moment format="DD/MM/YYYY HH:mm:ss">{reportedPost.createdDate}</Moment>
              </TableCell>
              <TableCell>
                {!reportedPost.archived
                  ? (
                    <IconButton onClick={() => {
                      reportService.updateArchive(reportedPost.id, { archived: true }).then(res => updateRow(reportedPost.id))
                    }}>
                      <ArchiveIcon />
                    </IconButton>
                    )
                  : (
                    <IconButton onClick={() => {
                      reportService.updateArchive(reportedPost.id, { archived: false }).then(res => updateRow(reportedPost.id))
                    }}>
                      <RecyclingIcon />
                    </IconButton>
                    )
                }
              </TableCell>
            </TableRow>
          ))}
          {!isLastPage && !loading
            ? (
              <TableRow>
                <Button onClick={paginationHandler}>Show More</Button>
              </TableRow>
              )
            : undefined
          }
          <TableLoading loading={loading} colSpan={3}/>
        </TableBody>
      </Table>
    </div>
  )
}

export default ReportedPostsPage
